import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import { CheckCircle, Warning, Error, Info, Close } from "@mui/icons-material";

export const CustomModal = ({
  visible,
  onClose,
  title,
  message,
  type = "info", // 'info', 'success', 'warning', 'error'
  buttons = [],
}) => {
  const getIconAndColor = () => {
    switch (type) {
      case "success":
        return { Icon: CheckCircle, color: "#4CAF50" };
      case "warning":
        return { Icon: Warning, color: "#FFC107" };
      case "error":
        return { Icon: Error, color: "#F44336" };
      default:
        return { Icon: Info, color: "#2196F3" };
    }
  };

  const { Icon, color } = getIconAndColor();

  return (
    <Modal
      open={visible}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <Close />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              bgcolor: `${color}20`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Icon sx={{ fontSize: 40, color }} />
          </Box>

          <Typography variant="h6" component="h2" gutterBottom>
            {title}
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            {message}
          </Typography>

          <Stack direction="row" spacing={2}>
            {buttons.length === 0 ? (
              <Button
                variant="contained"
                sx={{ bgcolor: color, "&:hover": { bgcolor: color } }}
                onClick={onClose}
              >
                OK
              </Button>
            ) : (
              buttons.map((button, index) => (
                <Button
                  key={index}
                  variant="contained"
                  sx={{
                    bgcolor: button.color || color,
                    "&:hover": { bgcolor: button.color || color },
                  }}
                  onClick={() => {
                    button.onPress?.();
                    onClose();
                  }}
                >
                  {button.text}
                </Button>
              ))
            )}
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};
